export const gaId = process.env.REACT_APP_GA_ID;
export const cannyId = process.env.REACT_APP_CANNY_ID;
export const contentfulToken = process.env.REACT_APP_CONTENTFUL_TOKEN;
export const contentfulSpace = process.env.REACT_APP_CONTENTFUL_SPACE;

export const GET_TEAMS_INTERVAL = 5000;
